module.exports = __webpack_public_path__ + "static/img/coho.6e3cf6b7.jpg";